import {Component, Input} from '@angular/core';
import {CustomFormControl} from '../custom-form-control';

@Component({
    selector: 'app-clause-radio',
    templateUrl: './clause-radio.component.html',
    styleUrls: ['./clause-radio.component.less'],
})
export class ClauseRadioComponent extends CustomFormControl {
    @Input() text: string;
    @Input() yesLabel = 'LABELS.YES';
    @Input() noLabel = 'LABELS.NO';
    @Input() owuNumber: string;

    public size = undefined;

    getDescription() {
        return this.text?.split('%s').join(this.owuNumber);
    }
}
